export const ATTACH_USER_TYPE = {
  NEW: 'new-student',
  EXISTING: 'existing-student',
};
